module.exports = new __parcel__URL__("vulcan--dataset-cover.c0dd17be.jpg").toString();